import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LocationSlider from '../locationslider/LocationSlider';
import CustModal from '../../common/custmodal/CustModal';
import RemoveModal from '../../common/removeModal/RemoveModal';
import MapViewModal from '../mapViewModal/MapViewModal';
import { getLocationTimeZone } from '../../../constants/constants';
import PDFIcon from '../../svgIcons/PDFIcon';
import iconLocation from '../../../images/icon-location.svg';
import iconDelete from '../../../images/icon-delete.svg';
import iconEdit from '../../../images/icon-edit.svg';
import styles from './LocationCard.module.css';
import MapIcon from '../../svgIcons/MapIcon';

export interface locationProps {
    isRestricted?: boolean;
    id: string;
    created_at: Date;
    updated_at: Date;
    name: string;
    street1: string;
    streetNumber: string;
    street2?: string;
    city: string;
    state: string;
    zip: string;
    country?: string;
    latitude?: number;
    longitude?: number;
    adminId: string;
    images: string[];
    timeZone: string;
    description: string;
    confirmText: string;
    provisioningId: number;
    masterCode: string;
    mapUrl: string;
    pmsPropertyId?: string;
    yardiId: string;
    listOfPOI: string;
    isLocationAvailable?: string;
    mappedInId: string | null;
    mapFilePath: string | null;
}
export interface propGroup {
    location: locationProps;
    canEditProperty: boolean;
    canDeleteProperty: boolean;
    onClick?: (_id: string) => void;
}


const LocationCard = ({ location, canEditProperty, canDeleteProperty, onClick }: propGroup) => {
    const navigate = useNavigate();
    const [deletePopup, setDeletePopup] = useState(false);
    const [locationId, setLocationId] = useState('');
    const [mapViewOpen, setMapViewOpen] = useState(false);

    // Only handle mapFilePath for PDF viewing
    const fileUrl = location?.mapFilePath || null;
    // Check if file extension ends with .pdf (case-insensitive)
    const fileType = location?.mapFilePath?.toLowerCase().endsWith('.pdf') ? 'pdf' : 'image';

    return (
        <>
            <CustModal
                open={deletePopup}
                setOpen={setDeletePopup}
                bodyData={<RemoveModal type={location.name} setDeletePopup={setDeletePopup} unitId={locationId} />}
            />

            <MapViewModal
                isOpen={mapViewOpen}
                onClose={() => setMapViewOpen(false)}
                propertyName={location.name}
                fileUrl={fileUrl}
                fileType={fileType}
            />

            <div key={location.id} className={styles.locationCard}>
                <div className={styles.card}>
                    <LocationSlider locationImgs={location.images} />
                    <div className={styles.locationDetails} onClick={() => onClick && onClick(location?.id)}>
                        <div className={styles.cardTitle}>
                            <div className={styles.cardName}>
                                <span>{location.name}</span>
                                <span className={styles.provisioningId}>(#{location.provisioningId})</span>
                            </div>
                            <div className={styles.cardActions}>
                                {canEditProperty && (
                                    <img
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigate(`/edit-location/${location.id}`);
                                        }}
                                        src={iconEdit}
                                    />
                                )}

                                {/* {userInfo && userInfo.role === 'super_admin' && ( */}
                                {canDeleteProperty && (
                                    <img
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setDeletePopup(true);
                                            setLocationId(location?.id);
                                        }}
                                        src={iconDelete}
                                        alt="delete"
                                    />
                                )}
                            </div>
                        </div>
                        <div className={styles.inlineLocationAvailability}>
                            <p
                                // onClick={() => navigate(`/location/${location.id}`, { state: { isRestricted: location?.isRestricted } })}
                                className={styles.locationTime}>
                                {getLocationTimeZone(location?.timeZone)}
                            </p>
                            {location?.mapFilePath && (
                                <div className={styles.rightContainer}>
                                    {location?.mapFilePath && !location?.mappedInId && (
                                        <div
                                            className={styles.mapIconContainer}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setMapViewOpen(true);
                                            }}
                                            title="View map">
                                            <PDFIcon width={24} height={24} fillColor="#f5004a" />
                                        </div>
                                    )}
                                    {location?.mappedInId && <MapIcon color="#51ab86" />}
                                    {location.isLocationAvailable == 'true' || <span className={styles.noAvailability}>NA</span>}
                                </div>
                            )}
                        </div>
                        <p
                            // onClick={() => navigate(`/location/${location.id}`, { state: { isRestricted: location?.isRestricted } })}
                            className={styles.locationAddress}>
                            <img src={iconLocation} alt="Location" />
                            {` ${location.streetNumber ? `${location.streetNumber},` : ''} ${location.street1}, ${location.city},
                                ${location.state
                            }, ${location.zip}`}
                        </p>
                        <p
                            // onClick={() => navigate(`/location/${location.id}`, { state: { isRestricted: location?.isRestricted } })}
                            className={styles.locationDesc}>
                            {location.description}
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LocationCard;
